module.exports = __webpack_public_path__ + "img/calculator.1e31433.png";